import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { PixKeysCreateModalInfoComponent } from './modal-info/modal-info.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CpfCnpjType } from '../../../../shared/enums/cpf-cnpj-type';
import { PixKeyType } from '../../models/key-type.enum';
import { Auth } from '../../../../autentication/Auth';
import { User } from '../../../../autentication/models/user';
import { PixKeysService } from '../keys.service';
import { EventTypes } from '../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { PixKey } from '../../models/key.model';
import { TransactionHistoryModule } from '../../../transaction-history/transaction-history.module';

@Component({
	selector: 'app-pix-keys-create',
	templateUrl: './create.component.html',
	styleUrls: ['./create.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysCreateComponent implements OnInit, AfterViewInit {

	public form: FormGroup;
	public maskCpfCnpj = '999.999.999-99';
	public selectedKeyType: PixKeyType = null;
	public user: User;
	public showAssignature = false;

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private formBuilder: FormBuilder,
		private pixKeysService: PixKeysService
	) {}

	ngOnInit(): void {
		this.buildForm();
		this.user = Auth.getInstance().getUser();
		this.openModalInfo();
	}

	ngAfterViewInit() {
		const onw = this;
		setTimeout(function() {
			onw.selectedKeyType = PixKeyType.CPF;
			onw.setRulesForCpfCnpj();
		});
	}

	buildForm() {
		this.form = this.formBuilder.group({
			cpfCnpj: { value: '', disabled: true },
			email: [''],
			phone: ['']
		});
	}

	selectKeyType(keyType: PixKeyType) {
		this.selectedKeyType = keyType;
		this.form.reset();
		this.resetAndUpdateValidators();

		switch (keyType) {
			case PixKeyType.CPF:
				this.setRulesForCpfCnpj();
				break;
			case PixKeyType.EMAIL:
				this.setRulesForEmail();
				break;
			case PixKeyType.PHONE:
				this.setRulesForPhoneNumber();
				break;
			case PixKeyType.EVP:
				this.setRulesForVirtualAddress();
				break;
		}
	}

	resetAndUpdateValidators() {
		this.form.get('cpfCnpj').clearValidators();
		this.form.get('email').clearValidators();
		this.form.get('phone').clearValidators();
		this.form.get('cpfCnpj').updateValueAndValidity();
		this.form.get('email').updateValueAndValidity();
		this.form.get('phone').updateValueAndValidity();
	}

	setRulesForCpfCnpj() {
		this.form.get('cpfCnpj').setValue(this.user.cpfCnpj);
		this.form.get('cpfCnpj').setValidators([Validators.required]);
		this.form.get('cpfCnpj').updateValueAndValidity();

		if (this.user.cpfCnpj.length > 11) {
			this.maskCpfCnpj = '99.999.999/9999-99';
		} else {
			this.maskCpfCnpj = '999.999.999-99';
		}
	}
	setRulesForEmail() {
		this.form.get('email').setValidators([Validators.required, Validators.email]);
		this.form.get('email').updateValueAndValidity();
	}

	setRulesForPhoneNumber() {
		this.form.get('phone').setValidators([Validators.required, Validators.minLength(11)]);
		this.form.get('phone').updateValueAndValidity();
	}

	setRulesForVirtualAddress() {
	}

	openModalInfo() {
		const onw = this;
		setTimeout(function() {
			onw.dialog.open(PixKeysCreateModalInfoComponent, { width: '350px' });
		}, 500);
	}

	changeType(e: any) {
		this.form.reset();
		this.form.get('createType').setValue(e.value);

		if (this.form.get('createType').value === CpfCnpjType.FISICA) {
			this.maskCpfCnpj = '999.999.999-99';
		} else {
			this.maskCpfCnpj = '99.999.999/9999-99';
		}
	}

	submit() {
		if (this.form.valid) {
			const pixKey = new PixKey();

			switch (this.selectedKeyType) {
				case PixKeyType.CPF:
					pixKey.codigo = this.form.get('cpfCnpj').value;
					pixKey.tipoChave = pixKey.codigo.length > 11 ? PixKeyType.CNPJ : PixKeyType.CPF;
					this.pixKeysService.setPixKey(pixKey);
					this.goToAssignature();
					break;
				case PixKeyType.EMAIL:
					pixKey.codigo = this.form.get('email').value;
					pixKey.tipoChave = PixKeyType.EMAIL;
					this.pixKeysService.setPixKey(pixKey);
					this.goToValidationCode();
					break;
				case PixKeyType.PHONE:
					pixKey.codigo = '+55' + this.form.get('phone').value;
					pixKey.tipoChave = PixKeyType.PHONE;
					this.pixKeysService.setPixKey(pixKey);
					this.goToValidationCode();
					break;
				case PixKeyType.EVP:
					pixKey.codigo = '';
					pixKey.tipoChave = PixKeyType.EVP;
					this.pixKeysService.setPixKey(pixKey);
					this.goToAssignature();
					break;
			}
		}
	}

	public get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	goToValidationCode = () => this.router.navigate(['pix/chaves/criar/validar-codigo/']);
	goToAssignature = () => this.router.navigate(['pix/chaves/criar/assinatura/']);


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/create/create.component.ts